import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "997cbc00-604b-4959-ad41-bee637418ced",
    content: "89 dB",
    options: {},
  },
  {
    id: "1399c05a-1183-473b-87d7-6a4ce25e8cae",
    content: "92 dB",
    options: {},
  },
  {
    id: "9ad74ba8-1bb8-46d3-aae0-6dd880849cf4",
    content: "101 dB",
    options: {},
  },
  {
    id: "cb78e0fe-6f4c-4a32-84eb-44ac6e582ca1",
    content: "91 dB",
    options: {},
  },
  {
    id: "9efb4f17-4213-4c8b-88d4-a43fccf16431",
    content: "95 dB",
    options: {},
  },
  {
    id: "764f9c91-d289-43bd-81fc-5f6857e6068f",
    content: "178 dB",
    options: {},
  },
];

export const task: Task = {
  id: "87cc6c85-027b-4c50-bb5d-f9ac136936ea",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["1399c05a-1183-473b-87d7-6a4ce25e8cae"],
};
